/* eslint-disable no-console */
import { availableAtScreenSize } from './utils';
import { getCookie, setCookie } from '../../utils/cookie-utils';
import { onIdleAfterDuration } from '../../utils/activity-utils';
import { removeAllErrors, validate } from '../../utils/form-validation-utils';
import SitePopup from '../site-popup';

const COOKIE_NAME = '200-pop-24hr';
const modalId = 'save-200-modal';
let modalDiv = null;
let modal = null;

const isAvailable = () => {
  const { location } = window;
  // Remove -modal from id before adding to params
  const shortId = modalId.substring(0, modalId.indexOf('-modal'));
  const url = `/api/IsSave200PopupNeeded?id=${shortId}&currentPage=${location}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.text().then(resolve);
        } else {
          response.text().then(reject);
        }
      })
      .catch(console.error);
  });
};

const isEmailSubmitted = (email) => {
  const url = `/api/PostPop200?email=${email}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const onSubmitClick = (event) => {
  const { gatorApi } = window;
  const form = modalDiv.querySelector('.save-200-form');
  const contentDiv = modalDiv.querySelector('.modal-content');
  const altContentDiv = modalDiv.querySelector('.modal-alternate-content');

  event.preventDefault();
  removeAllErrors(form);
  if (!validate(form)) {
    modal.updateHeight();
    return;
  }
  const email = modalDiv.querySelector('#save-200-email').value;
  // Log with gator.io
  if (gatorApi) {
    gatorApi.log('Pop 200', '', '', '', email, '');
  }
  // Submit form
  isEmailSubmitted(email)
    .then((data) => {
      if (data.isOk) {
        contentDiv.classList.add('hidden');
        altContentDiv.classList.remove('hidden');
        modal.updateHeight();
      }
    });
};

const initModal = (modalHtml) => {
  // Append html to the end of the DOM
  const body = document.querySelector('body');
  const div = document.createElement('div');
  div.innerHTML = modalHtml.trim();
  body.appendChild(div.firstChild);
  // Define div references
  modalDiv = document.getElementById(modalId);
  const submitBtn = modalDiv.querySelector('.submit-btn');
  // Delay before showing pop-up
  onIdleAfterDuration(3000, () => {
    modal = new SitePopup({
      callbacks: {
        onOpen: () => {
          setCookie(COOKIE_NAME, 'yes', 1); // Set to last for only one day
          submitBtn.addEventListener('click', onSubmitClick);
        },
      },
      id: modalId,
    });
    modal.open();
  });
};

const save200Popup = () => {
  const { sitePopupsEnabled } = window;

  const popupCriteria = availableAtScreenSize() && sitePopupsEnabled && getCookie(COOKIE_NAME) === '';
  if (!popupCriteria) {
    return;
  }

  isAvailable()
    .then((data) => {
      if (data !== '~error~') {
        initModal(data);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export default save200Popup;
/* eslint-enable no-console */
